import { render } from "./App.vue?vue&type=template&id=11ba92d7"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "../public/site.css?vue&type=style&index=1&lang=css"

import exportComponent from "/builds/tel/jcr/ungerboeck_tables/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__